import React from "react";
import ViewProduct from "../../components/product/ViewProduct";
import Navbar from "../../components/common/navbar/Navbar";

const ViewProductPage = () => {
    return (
        <>
            <section className="bajaj_main_block">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12 p-0">
                            <Navbar content="VIEW PRODUCT" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12 p-0">
                            <ViewProduct />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ViewProductPage;
